import React, { useState, useEffect } from 'react';
import { useNavigate, Routes, Route, Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import DashboardHome from './DashboardHome';
import Profile from './Profile';
import Addresses from './Addresses';
import Orders from './Orders';
import Subscriptions from './Subscriptions';
import './Dashboard.css';

const Dashboard = () => {
  const { user, logout, loading, processGoogleSession } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [processingOAuth, setProcessingOAuth] = useState(false);

  // Handle Google OAuth redirect
  useEffect(() => {
    const hash = window.location.hash;
    if (hash && hash.includes('session_id=')) {
      setProcessingOAuth(true);
      const sessionId = hash.split('session_id=')[1].split('&')[0];
      
      processGoogleSession(sessionId).then((result) => {
        if (result.success) {
          window.history.replaceState({}, document.title, window.location.pathname);
          setProcessingOAuth(false);
        } else {
          alert('Google sign-in failed. Please try again.');
          setProcessingOAuth(false);
          navigate('/login');
        }
      });
    }
  }, [processGoogleSession, navigate]);

  const handleLogout = async () => {
    const result = await logout();
    if (result.success) {
      navigate('/login');
    }
  };

  if (loading || processingOAuth) {
    return (
      <div className="account-loading">
        <div className="spinner"></div>
        <p>{processingOAuth ? 'Completing sign-in...' : 'Loading...'}</p>
      </div>
    );
  }

  const tabs = [
    { path: '/dashboard', label: 'Overview' },
    { path: '/dashboard/orders', label: 'My Orders' },
    { path: '/dashboard/subscriptions', label: 'Subscriptions' },
    { path: '/dashboard/addresses', label: 'Addresses' },
    { path: '/dashboard/profile', label: 'Account Settings' }
  ];

  const currentTab = tabs.find(tab => tab.path === location.pathname) || tabs[0];

  return (
    <div className="account-container">
      {/* Header */}
      <div className="account-header">
        <div className="account-header-content">
          <div className="account-greeting">
            <Link to="/" className="back-to-shop">← Back to Shop</Link>
            <h1>Hi, {user?.name?.split(' ')[0]}! 👋</h1>
            <p>Manage your orders, subscriptions, and account details</p>
          </div>
          <button className="btn-logout" onClick={handleLogout}>
            Sign Out
          </button>
        </div>
      </div>

      {/* Tab Navigation */}
      <div className="account-tabs">
        <div className="tabs-container">
          {tabs.map((tab) => (
            <Link
              key={tab.path}
              to={tab.path}
              className={`tab ${location.pathname === tab.path ? 'active' : ''}`}
            >
              {tab.label}
            </Link>
          ))}
        </div>
      </div>

      {/* Main Content */}
      <main className="account-main">
        <div className="account-content">
          <Routes>
            <Route index element={<DashboardHome />} />
            <Route path="orders" element={<Orders />} />
            <Route path="subscriptions" element={<Subscriptions />} />
            <Route path="addresses" element={<Addresses />} />
            <Route path="profile" element={<Profile />} />
          </Routes>
        </div>
      </main>
    </div>
  );
};

export default Dashboard;